import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { selectStoryRecordToEdit } from '@src/suite/common/store/fullscreen';
import { MosActions } from '@src/suite/common/store/mos/actions/mos.actions';
import { selectCurrentMos } from '@src/suite/common/store/mos/selectors/mos.selectors';
import { StoryActions } from '@src/suite/common/store/story/actions/story.actions';
import { convertMosItemFromPlugin, getMosCommand, MosCommand, ncsAppInfoResponse, ncsItemRequestResponse } from '@src/suite/common/utils/mos-utlis';
import { map } from 'rxjs';

@Injectable()
export class MosEffects {
    constructor(
        private actions$: Actions,
        private store: Store
    ) {}

    handleClientMosCommand$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(MosActions.mosClientCommandSend),
                concatLatestFrom(() => [this.store.select(selectStoryRecordToEdit), this.store.select(selectCurrentMos)]),
                map(([_action, _story, _currentMos]) => {
                    // console.log('mosClientCommandSend', action.command, story, currentMos);
                })
            );
        },
        { dispatch: false }
    );

    handleMosCommand$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(MosActions.mosServerCommandSend),
            concatLatestFrom(() => [this.store.select(selectStoryRecordToEdit), this.store.select(selectCurrentMos)]),
            map(([action, story, currentMos]) => {
                const mosCommand = getMosCommand(action.command);
                switch (mosCommand) {
                    case MosCommand.ncsAck:
                        // skip ncsAck, for now
                        // TODO: handle ncsAck later in some way
                        return MosActions.mosClientCommandSend({ command: '' });
                    case MosCommand.ncsReqAppInfo:
                        return MosActions.mosClientCommandSend({
                            command: ncsAppInfoResponse({
                                mosDeviceId: action.mosPluginId,
                                userId: 'NED',
                                viewPort: {
                                    x: 1920,
                                    y: 1080,
                                },
                            }),
                        });
                    case MosCommand.ncsItem:
                        // TODO: instead of passing mos string we should pass the xml object
                        return StoryActions.addMosItem({ storyId: story?.Guid, mosStr: convertMosItemFromPlugin(action.command), mosPluginId: action.mosPluginId });
                    case MosCommand.mosItemReplace:
                        // TODO: instead of passing mos string we should pass the xml object
                        return StoryActions.replaceMosItem({
                            storyId: currentMos.storyId,
                            mosStr: convertMosItemFromPlugin(action.command),
                            mosElId: currentMos.mosElementId,
                            mosPluginId: action.mosPluginId,
                        });
                }
                return MosActions.mosClientCommandSend({ command: '' });
            })
        );
    });

    onMosItemClicked$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(MosActions.mosOjbClicked),
            concatLatestFrom(() => this.store.select(selectStoryRecordToEdit)),
            map(([action, story]) => {
                const mosObj = story?.TextCommands?.[action.mosElemntId];
                if (mosObj) {
                    return MosActions.mosClientCommandSend({ command: ncsItemRequestResponse(mosObj) });
                } else {
                    // TODO: handle non mos case
                    return MosActions.mosClientCommandSend({ command: '' });
                }
            })
        );
    });
}

/*
When Mos plugin send mosItemReplace, if the story doesn't match to the current one, send ncsAck with error message. If the story matches, replace the item and send ncsAck with success message.
*/
